<script>
import anime from 'animejs';

function getX(angle, length) {
    return Math.round(length * Math.cos((angle * Math.PI) / 180));
}

function getY(angle, length) {
    return Math.round(length * Math.sin((angle * Math.PI) / 180));
}

function getPositionAtCenter(element) {
    const { top, left, width, height } = element.getBoundingClientRect();
    return {
        x: left + width / 2,
        y: top + height / 2,
    };
}

function getOffsetBetweenElements(a, b) {
    const aPosition = getPositionAtCenter(a);
    const bPosition = getPositionAtCenter(b);
    return {
        x: aPosition.x - bPosition.x,
        y: aPosition.y - bPosition.y,
    };
}

function moveGem(destinationElementId, particles) {
    let source = document.getElementById('particles-source');
    let destination = document.getElementById(destinationElementId);
    const diff = getOffsetBetweenElements(destination, source);
    const timeline = anime.timeline({
        targets: particles,
    });

    timeline
        .add({
            duration: 750,
            easing: 'easeOutExpo',
            translateX: (el, i, l) => getX((i * 360) / l, anime.random(25, 50)),
            translateY: (el, i, l) => getY((i * 360) / l, anime.random(25, 50)),
            delay: anime.stagger(10),
        })
        .add(
            {
                duration: 750,
                easing: 'easeInExpo',
                translateX: diff.x,
                translateY: diff.y,
                delay: anime.stagger(100),
            },
            '-=450',
        )
        .add({
            duration: 1,
            opacity: 0,
        });

    return timeline.finished;
}

export default {
    emits: ['finished'],
    name: 'CurrencyPointsAnimation',
    props: ['order', 'reference', 'count', 'type'],

    data() {
        return {
            show: false,
        };
    },

    methods: {
        run() {
            this.show = true;
            this.$nextTick(() => {
                moveGem(this.reference, this.$refs.gems).then(() => {
                    this.$emit('finished');
                });
            });
        },
    },

    mounted() {
        this.run();
    },

    computed: {
        image: function () {
            if (this.type === 'coins') {
                return '/assets/gamification/currency/coin.svg';
            }

            return '/assets/gamification/currency/emerald.svg';
        },
    },
};
</script>

<template>
    <div>
        <Teleport to="#particles-origin" :order="order">
            <div
                class="gem absolute top-0 left-0 z-10"
                v-for="i in count"
                :key="`particle_${reference}_${i}`"
                ref="gems"
            >
                <!--suppress HtmlUnknownTarget -->
                <img class="h-6 w-6" :src="image" alt="emerald" />
            </div>
        </Teleport>
    </div>
</template>
